import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom"; // Import para acessar o contexto do Outlet
import RequestService from "../services/RequestService";
import { FaCircle } from "react-icons/fa";
import { parseISO, format } from "date-fns";
import RequestDetailsModal from "./modals/RequestDetailsModal";
import { FaLongArrowAltDown } from "react-icons/fa";
import CancelModal from './modals/CancelModal';
import StatusRequests from './../enums/StatusRequests';
import { FaFileExcel } from "react-icons/fa";
import exportToExcelMinhasSolicitacoes from '../utils/exportToExcelMinhasSolicitacoes';
import CreateReverseModal from "./modals/Reverse/CreateReverseModal";
import { FaSpinner } from "react-icons/fa";
import { startPolling } from "../utils/polling";


export default function MyRequests() {

  // const { user } = useOutletContext(); // Acessa o usuário diretamente
  const { user = {} } = useOutletContext() || {};

  const [cancelModal, setCancelModal] = useState(false);
  const [requestOnCancelModal, setRequestOnCancelModal] = useState();
  const [requestDetailsModal, setRequestDetailsModal] = useState(false);
  const [requestOnDetailsModal, setRequestOnDetailsModal] = useState();
  
  const [createReverseModal, setCreateReverseModal] = useState(false);
  const [requestOnCreateReverseModal, setRequestOnCreateReverseModal] = useState();

  //filters
  const [search, setSearch] = useState('');
  const [tempSearch, setTempSearch] = useState(''); // Estado temporário para o input
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  // const [status, setStatus] = useState('');
  const [searchStatus, setSearchStatus] = useState('');

  const [companySearch, setCompanySearch] = useState('');
  const [companyTempSearch, setCompanyTempSearch] = useState('');
  const [companyStartDate, setCompanyStartDate] = useState('');
  const [companyEndDate, setCompanyEndDate] = useState('');

  const [requestList, setRequestList] = useState({ requests: [], totalPages: 1 });
  const [currentPageRequests, setCurrentPageRequests] = useState(1);

  const [companyRequestList, setCompanyRequestList] = useState({ requests: [], totalPages: 1 });
  const [currentPageCompanyRequests, setCurrentPageCompanyRequests] = useState(1);

  const [isLoadingCompanyRequests, setIsLoadingCompanyRequests] = useState(false);

  useEffect(() => {
  
    // Função para buscar os requests
    const fetchRequests = async () => {

      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      // if (status) params.append('status', status);

      const queryString = params.toString();
      const myRequests = await RequestService.getMyRequests(`?${queryString}`, currentPageRequests, 10);
      setRequestList(myRequests);
    };

    // Chamada inicial
    fetchRequests();

    return startPolling(fetchRequests);

  }, [cancelModal, currentPageRequests, endDate, search, startDate, createReverseModal]);

  const handleRequestDetailsModal = async (ticketId) => {
    setRequestDetailsModal(true)
    setRequestOnDetailsModal(ticketId)
  };

  const handleCancel = async (requestId) => {

    setCancelModal(true)
    setRequestOnCancelModal(requestId)

  }

  const handleCreateReverse = async (requestId) => {

    setCreateReverseModal(true)
    setRequestOnCreateReverseModal(requestId)

  }

  // const clearFilters = () => {
  //   setSearch('');
  //   setStartDate('');
  //   setEndDate('');
  //   // setStatus('');
  // };

  // const handleSearchChange = (e) => {
  //   setSearch(e.target.value);
  //   console.log(e.target.value)
  // };

  // const handleStartDateChange = (e) => {
  //   setStartDate(e.target.value);
  //   console.log(e.target.value)
  // };

  // const handleEndDateChange = (e) => {
  //   setEndDate(e.target.value);
  //   console.log(e.target.value)
  // };

  // const handleStatusChange = (e) => {
  //   setStatus(e.target.value);
  //   console.log(e.target.value)
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // Implement your search logic here
  //   console.log('Search:', search);
  //   console.log('Start Date:', startDate);
  //   console.log('End Date:', endDate);
  //   // console.log('Status:', status);
  // };

  const handlePageChangeRequests = (newPage) => {
    if (newPage >= 1 && newPage <= requestList.totalPages) {
      setCurrentPageRequests(newPage);
    }
  };

  // ====== FILTER FUNCTIONS ====== 

  const clearFilters = () => {
    setSearch('');
    setTempSearch('');
    setStartDate('');
    setEndDate('');
    // setStatus('');
  };

  const handleSearchChange = (e) => {
    // setSearch(e.target.value);
    setTempSearch(e.target.value); // Atualiza o estado temporário
    setCurrentPageRequests(1); // Redefine a página para 1 ao alterar o filtro de pesquisa
    setCurrentPageCompanyRequests(1)
  };

  const handleSearchBlur = () => {
    setSearch(tempSearch); // Atualiza o estado principal quando o input perde o foco
    console.log(tempSearch);
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    console.log(e.target.value)
    setCurrentPageRequests(1); // Redefine a página para 1 ao alterar o filtro de pesquisa
    setCurrentPageCompanyRequests(1)
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    console.log(e.target.value)
    setCurrentPageRequests(1); // Redefine a página para 1 ao alterar o filtro de pesquisa
    setCurrentPageCompanyRequests(1)
  };

  // === FILTRO DE COMPANY

  const clearCompanyFilters = () => {
    setCompanySearch('');
    setCompanyTempSearch('');
    setCompanyStartDate('');
    setCompanyEndDate('');
    setCompanyRequestList({ requests: [], totalPages: 1 }); // Esvazia a lista de solicitações da empresa
    setSearchStatus('')
  };
  
  const handleCompanySearchChange = (e) => {
    setCompanyTempSearch(e.target.value);
    setCurrentPageCompanyRequests(1);
  };
  
  const handleCompanySearchBlur = () => {
    setCompanySearch(companyTempSearch);
  };
  
  const handleCompanyStartDateChange = (e) => {
    setCompanyStartDate(e.target.value);
    setCurrentPageCompanyRequests(1);
  };
  
  const handleCompanyEndDateChange = (e) => {
    setCompanyEndDate(e.target.value);
    setCurrentPageCompanyRequests(1);
  };

  // ====== END FILTER FUNCTIONS ====== 

  const fetchCompanyRequests = async (page = currentPageCompanyRequests) => {
    setIsLoadingCompanyRequests(true);
    const params = new URLSearchParams();
    if (companySearch) params.append('search', companySearch);
    if (companyStartDate) params.append('startDate', companyStartDate);
    if (companyEndDate) params.append('endDate', companyEndDate);
    if (searchStatus) params.append('status', searchStatus);
  
    const queryString = params.toString();
    const companyRequests = await RequestService.getMyCompanyRequests(`?${queryString}`, page, 10);
    setCompanyRequestList(companyRequests);
    setIsLoadingCompanyRequests(false);
  };
  
  const handlePageChangeCompanyRequests = async (newPage) => {
    if (newPage >= 1 && newPage <= companyRequestList.totalPages) {
      setCurrentPageCompanyRequests(newPage); // Atualiza o estado
      await fetchCompanyRequests(newPage); // Chama a função com o valor da página clicada
    }
  };

  const handleExportToExcel = async () => {

    const params = new URLSearchParams();
    // if (searchUF) params.append('uf', searchUF);
    // if (searchStatus) params.append('status', searchStatus);
    // if (searchIdRequest) params.append('idrequest', searchIdRequest);
    // if (searchTecnico) params.append('tecnico', searchTecnico);
    // if (searchEmpresa) params.append('company', searchEmpresa);
    // if (searchCodSap) params.append('codsap', searchCodSap);
    // if (searchTipoAtendimento) params.append('tipoatendimento', searchTipoAtendimento);
    // if (searchIdBoleto) params.append('idboleto', searchIdBoleto);
    // if (searchTipoBoleto) params.append('tipoboleto', searchTipoBoleto);
    // if (searchSite) params.append('site', searchSite);
    // if (searchGmo) params.append('gmo', searchGmo);
    // if (searchDrsOrigem) params.append('drsorigem', searchDrsOrigem);
    // if (searchQtdSolicitadaPrefix) params.append('qtdsolprefix', searchQtdSolicitadaPrefix);
    // if (searchQtdSolicitada) params.append('qtdsol', searchQtdSolicitada);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
  
    const queryString = params.toString();
    const requestsExcel = await RequestService.getMyRequests(`?${queryString}`, currentPageRequests, 0, true);
  
    // setRequestListExcel(requestsExcel);
    exportToExcelMinhasSolicitacoes(requestsExcel.requests)
  }

  const handleExportToExcelCompany = async () => {

    const params = new URLSearchParams();
    // if (searchUF) params.append('uf', searchUF);
    // if (searchStatus) params.append('status', searchStatus);
    // if (searchIdRequest) params.append('idrequest', searchIdRequest);
    // if (searchTecnico) params.append('tecnico', searchTecnico);
    // if (searchEmpresa) params.append('company', searchEmpresa);
    // if (searchCodSap) params.append('codsap', searchCodSap);
    // if (searchTipoAtendimento) params.append('tipoatendimento', searchTipoAtendimento);
    // if (searchIdBoleto) params.append('idboleto', searchIdBoleto);
    // if (searchTipoBoleto) params.append('tipoboleto', searchTipoBoleto);
    // if (searchSite) params.append('site', searchSite);
    // if (searchGmo) params.append('gmo', searchGmo);
    // if (searchDrsOrigem) params.append('drsorigem', searchDrsOrigem);
    // if (searchQtdSolicitadaPrefix) params.append('qtdsolprefix', searchQtdSolicitadaPrefix);
    // if (searchQtdSolicitada) params.append('qtdsol', searchQtdSolicitada);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
  
    const queryString = params.toString();
    const requestsExcel = await RequestService.getMyCompanyRequests(`?${queryString}`, currentPageRequests, 0, true);
  
    // setRequestListExcel(requestsExcel);
    exportToExcelMinhasSolicitacoes(requestsExcel.requests)
  }


  return (
    <div className="flex w-full h-full justify-center items-center py-4 px-4 bg-gray-200">
  
      <div className="flex flex-col w-full min-h-full rounded-xl py-8 px-6 gap-12 bg-white">
  
        <div className="flex flex-col gap-2 border border-gray-800 border-opacity-40 rounded-xl p-2">
          <div className="flex items-center gap-2 w-full text-sm font-semibold ps-2 mt-2">

            <div className="w-full text-md font-semibold ps-2 mt-2">
              Minhas Solicitações
            </div>

            <button onClick={() => handleExportToExcel(requestList.requests)} className="flex justify-center items-center bg-green-600 px-2 py-1 rounded-lg text-white gap-2">
              <FaFileExcel />
              <div>Exportar</div>
            </button>
          </div>

          {/* My Requests */}
          <div className="w-full flex flex-col gap-4">
  
            {/* Filtros de Busca */}
            <div className="flex items-end w-full rounded-md gap-4 mt-2 text-[10px]">
              <div className="flex space-x-4 text-[12px]">
                <div className="flex flex-col">
                  <label className="font-semibold ms-2">Pesquisar</label>
                  <input
                    type="text"
                    placeholder="Search"
                    value={tempSearch}  // Vincula o valor ao estado temporário
                    onChange={handleSearchChange}  // Atualiza o estado temporário em tempo real
                    onBlur={handleSearchBlur}  // Atualiza o estado principal ao perder o foco
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold ms-2">Data Início</label>
                  <input
                    type="date"
                    placeholder="Start Date"
                    value={startDate}
                    onChange={handleStartDateChange}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold ms-2">Data Fim</label>
                  <input
                    type="date"
                    placeholder="End Date"
                    value={endDate}
                    onChange={handleEndDateChange}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
              </div>
  
              <div className="flex gap-2">
                <button onClick={clearFilters} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                  Limpar Filtros
                </button>             
              </div>
            </div>
  
            {/* Tabela */}
            <div className="w-full">
            <div className="flex gap-1 ms-2 text-xs">Total: <div className="font-bold">{requestList?.totalRequests} registros</div></div>
              <div className="overflow-x-auto min-h-48">
                <table className="min-w-full bg-white rounded-lg text-[10px]">
                  <thead className="bg-indigo-400">
                    <tr>
                      <th className="py-2 px-4 border-b rounded-tl-lg">Status</th>
                      <th className="py-2 px-4 border-b">ID</th>
                      <th className="py-2 px-4 border-b">Criado em</th>
                      <th className="py-2 px-4 border-b">Técnico</th>
                      <th className="py-2 px-4 border-b">Empresa</th>
                      <th className="py-2 px-4 border-b">GMO</th>
                      <th className="py-2 px-4 border-b">Cod Sap</th>
                      <th className="py-2 px-2 border-b w-8">DRS Original</th>
                      <th className="py-2 px-2 border-b w-8">DRS Atender</th>
                      <th className="py-2 px-1 border-b w-8 bg-indigo-500">Qtd Solicitada</th>
                      <th className="py-2 px-1 border-b w-8 bg-indigo-500">Qtd Cortada</th>
                      <th className="py-2 px-1 border-b w-8 bg-indigo-500">Qtd Atender</th>
                      <th className="py-2 px-1 border-b w-8 bg-indigo-300">Resta Coletar</th>
                      <th className="py-2 px-4 border-b">Atendimento</th>
                      <th className="py-2 px-4 border-b"><div className="flex justify-center items-center">Data SLA<FaLongArrowAltDown /></div></th>
                      <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {requestList.requests?.map((request, index) => (
                      <tr key={index} className="border-b hover:bg-gray-100">
                        <td className="py-1 px-4">
                          <div className="flex justify-start items-center gap-2">
                            <FaCircle
                              color={StatusRequests[`${request.status}`]?.cor}
                              size={15}
                            />
                            {request.status}
                          </div>
                        </td>
                        <td className="py-1 px-4 cursor-pointer underline font-bold" onClick={()=>handleRequestDetailsModal(request._id)}><div className="flex justify-center items-center gap-2">{request.idRequest}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{format(parseISO(request.createdAt), 'dd/MM/yy HH:mm')}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.tecnico || request.nomeSolicitante}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.empresaTecnico?.socialName || request.empresaSolicitante}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.gmo.cidade} - {request.gmo.uf}</div></td>
                        <td className="py-1 px-4 whitespace-nowrap"><div className="flex justify-center items-center gap-2">{request.codSap}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.drsOriginal?.sigla}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.drsAtender?.sigla}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeSolicitada}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeCortada}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeAtender}</div></td>
                        <td className={`py-1 px-4 ${request.reverses?.quantidadeRestante > 0 ? 'bg-yellow-200' : ''}`}><div className="flex justify-center items-center gap-2"></div>{request.reverses?.quantidadeRestante}</td>
                        <td className="py-1 px-4">
                          <div className="flex justify-center items-center gap-2">
                            {["bbn-alta", "bbn-media"].includes(request.tipoAtendimento) ? (
                              <span className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                                {request.tipoAtendimento.toUpperCase()}
                              </span>
                            ) : (
                              request.tipoAtendimento.toUpperCase()
                            )}
                          </div>
                        </td>
                        <td className="py-1 px-4">
                          <div className="flex justify-center items-center gap-2">{request?.slaDate ? format(parseISO(request.slaDate), 'dd/MM/yy HH:mm') : ""}</div>
                        </td>
                        <td className="py-1 px-4">
                          <div className="flex justify-center gap-2 h-5 text-[11px]">
                            {(request.status === 'NOVO') &&
                              <button
                                className="bg-neutral-300 rounded-full px-2 text-black text-xs font-semibold"
                                onClick={()=>handleCancel(request._id)}
                              >
                                Cancelar
                              </button>
                            }
                            {!request.reverses &&

                              <button
                                className="bg-yellow-300 rounded-full px-2 text-black text-xs"
                                onClick={() => handleCreateReverse(request._id)}
                              >
                                +Reversa
                              </button>

                            }
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Paginação para Minhas Solicitações */}
              <div className="flex justify-center items-center mt-4 gap-2 text-xs">
                <button
                  onClick={() => handlePageChangeRequests(currentPageRequests - 1)}
                  disabled={currentPageRequests === 1}
                  className={`px-2 py-1 rounded-md ${currentPageRequests === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                >
                  {'<'}
                </button>

                {/* Botão para a primeira página */}
                {currentPageRequests > 2 && (
                  <>
                    <button
                      onClick={() => handlePageChangeRequests(1)}
                      className="px-2 py-1 rounded-md bg-gray-300"
                    >
                      1
                    </button>
                    {currentPageRequests >= 3 && <span className="px-2 py-1">...</span>}
                  </>
                )}

                {/* Botões ao redor da página atual */}
                {Array.from({ length: 3 }, (_, i) => {
                  const page = currentPageRequests - 1 + i;
                  if (page > 0 && page <= requestList.totalPages) {
                    return (
                      <button
                        key={page}
                        onClick={() => handlePageChangeRequests(page)}
                        className={`px-2 py-1 rounded-md ${page === currentPageRequests ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                      >
                        {page}
                      </button>
                    );
                  }
                  return null;
                })}

                {/* Botão para a última página */}
                {currentPageRequests < requestList.totalPages - 1 && (
                  <>
                    {currentPageRequests < requestList.totalPages - 2 && <span className="px-2 py-1">...</span>}
                    <button
                      onClick={() => handlePageChangeRequests(requestList.totalPages)}
                      className="px-2 py-1 rounded-md bg-gray-300"
                    >
                      {requestList.totalPages}
                    </button>
                  </>
                )}

                <button
                  onClick={() => handlePageChangeRequests(currentPageRequests + 1)}
                  disabled={currentPageRequests === requestList.totalPages}
                  className={`px-2 py-1 rounded-md ${currentPageRequests === requestList.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                >
                  {'>'}
                </button>
              </div>

            </div>
          </div>

          <div className="flex items-center gap-2 w-full text-sm font-semibold ps-2 mt-2">

            <div className="w-full text-md font-semibold ps-2 mt-2">
              Solicitações {user?.company?.name}
            </div>

            <button onClick={() => handleExportToExcelCompany(requestList.requests)} className="flex justify-center items-center bg-green-600 px-2 py-1 rounded-lg text-white gap-2">
              <FaFileExcel />
              <div>Exportar</div>
            </button>
          </div>

          {/* My Company */}
          <div className="w-full flex flex-col gap-4">

            {/* Filtros de Busca */}
            <div className="flex items-end w-full rounded-md gap-4 mt-2 text-[10px]">
              <div className="flex space-x-4 text-[12px]">
                <div className="flex flex-col">
                  <label className="font-semibold ms-2">Pesquisar</label>
                  <input
                    type="text"
                    placeholder="Search"
                    value={companyTempSearch}
                    onChange={handleCompanySearchChange}
                    onBlur={handleCompanySearchBlur}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold ms-2">Data Início</label>
                  <input
                    type="date"
                    placeholder="Start Date"
                    value={companyStartDate}
                    onChange={handleCompanyStartDateChange}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold ms-2">Data Fim</label>
                  <input
                    type="date"
                    placeholder="End Date"
                    value={companyEndDate}
                    onChange={handleCompanyEndDateChange}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold ms-2">Status</label>
                  <select
                    defaultValue=""
                    value={searchStatus}
                    onChange={(e) => setSearchStatus(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  >
                    <option value="" disabled>Selecione</option>
                    {Object.keys(StatusRequests).map((key, index) => (
                      <option key={index} value={key}>{StatusRequests[key].descricao}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="flex gap-2">
                <button onClick={clearCompanyFilters} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                  Limpar Filtros
                </button>
                <button onClick={fetchCompanyRequests} className="bg-blue-600 hover:bg-blue-500 text-white h-5 px-4 rounded-2xl w-40">
                  Buscar
                </button>
              </div>
            </div>
  
            {/* Tabela */}
            <div className="w-full">
              <div className="flex gap-1 ms-2 text-xs">
                Total: <div className="font-bold">{companyRequestList?.totalRequests || 0} registros</div>
              </div>
              {isLoadingCompanyRequests ? (
                <div className="text-center text-gray-500 mt-4 flex justify-center items-center gap-2">
                <FaSpinner className="animate-spin text-xl" />
                Carregando...
              </div>
              ) : companyRequestList.requests.length > 0 ? (
                <div className="overflow-x-auto min-h-48">
                  <table className="min-w-full bg-white rounded-lg text-[10px]">
                    <thead className="bg-gray-300">
                      <tr>
                        <th className="py-2 px-4 border-b rounded-tl-lg">Status</th>
                        <th className="py-2 px-4 border-b">ID</th>
                        <th className="py-2 px-4 border-b">Criado em</th>
                        <th className="py-2 px-4 border-b">Técnico</th>
                        <th className="py-2 px-4 border-b">Empresa</th>
                        <th className="py-2 px-4 border-b">Cod Sap</th>
                        <th className="py-2 px-2 border-b w-8">DRS Original</th>
                        <th className="py-2 px-2 border-b w-8">DRS Atender</th>
                        <th className="py-2 px-1 border-b w-8 bg-gray-400">Qtd Solicitada</th>
                        <th className="py-2 px-1 border-b w-8 bg-gray-400">Qtd Cortada</th>
                        <th className="py-2 px-1 border-b w-8 bg-gray-400">Qtd Atender</th>
                        <th className="py-2 px-1 border-b w-8 bg-gray-200">Resta Coletar</th>
                        <th className="py-2 px-4 border-b">Atendimento</th>
                        <th className="py-2 px-4 border-b">
                          <div className="flex justify-center items-center">
                            Data SLA
                            <FaLongArrowAltDown />
                          </div>
                        </th>
                        <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                      </tr>
                    </thead>
                    <tbody>
                      {companyRequestList.requests.map((request, index) => (
                        <tr key={index} className="border-b hover:bg-gray-100">
                          <td className="py-1 px-4">
                            <div className="flex justify-start items-center gap-2">
                              <FaCircle
                                color={StatusRequests[`${request.status}`]?.cor}
                                size={15}
                              />
                              {request.status}
                            </div>
                          </td>
                          <td
                            className="py-1 px-4 cursor-pointer underline font-bold"
                            onClick={() => handleRequestDetailsModal(request._id)}
                          >
                            <div className="flex justify-center items-center gap-2">
                              {request.idRequest}
                            </div>
                          </td>
                          <td className="py-1 px-4">
                            <div className="flex justify-center items-center gap-2">
                              {format(parseISO(request.createdAt), "dd/MM/yy HH:mm")}
                            </div>
                          </td>
                          <td className="py-1 px-4">
                            <div className="flex justify-center items-center gap-2">
                              {request.tecnico || request.nomeSolicitante}
                            </div>
                          </td>
                          <td className="py-1 px-4">
                            <div className="flex justify-center items-center gap-2">
                              {request.empresaTecnico?.socialName || request.empresaSolicitante}
                            </div>
                          </td>
                          <td className="py-1 px-4 whitespace-nowrap">
                            <div className="flex justify-center items-center gap-2">
                              {request.codSap}
                            </div>
                          </td>
                          <td className="py-1 px-4">
                            <div className="flex justify-center items-center gap-2">
                              {request.drsOriginal?.sigla}
                            </div>
                          </td>
                          <td className="py-1 px-4">
                            <div className="flex justify-center items-center gap-2">
                              {request.drsAtender?.sigla}
                            </div>
                          </td>
                          <td className="py-1 px-4">
                            <div className="flex justify-center items-center gap-2">
                              {request.quantidadeSolicitada}
                            </div>
                          </td>
                          <td className="py-1 px-4">
                            <div className="flex justify-center items-center gap-2">
                              {request.quantidadeCortada}
                            </div>
                          </td>
                          <td className="py-1 px-4">
                            <div className="flex justify-center items-center gap-2">
                              {request.quantidadeAtender}
                            </div>
                          </td>
                          <td
                            className={`py-1 px-4 ${request.reverses?.quantidadeRestante > 0 ? "bg-yellow-200" : ""
                              }`}
                          >
                            <div className="flex justify-center items-center gap-2"></div>
                            {request.reverses?.quantidadeRestante}
                          </td>
                          <td className="py-1 px-4">
                            <div className="flex justify-center items-center gap-2">
                              {request.tipoAtendimento.toUpperCase()}
                            </div>
                          </td>
                          <td className="py-1 px-4">
                            <div className="flex justify-center items-center gap-2">
                              {request?.slaDate
                                ? format(parseISO(request.slaDate), "dd/MM/yy HH:mm")
                                : ""}
                            </div>
                          </td>
                          <td className="py-1 px-4">
                            <div className="flex justify-center gap-2 h-5 text-[11px]">
                              {!request.reverses && (
                                <button
                                  className="bg-yellow-300 rounded-full px-2 text-black text-xs"
                                  onClick={() => handleCreateReverse(request._id)}
                                >
                                  +Reversa
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="text-center text-gray-500 mt-4">Nenhuma solicitação encontrada.</div>
              )}

              {/* Paginação para Solicitações da Empresa */}
              <div className="flex justify-center items-center mt-4 gap-2 text-xs">
                <button
                  onClick={() => handlePageChangeCompanyRequests(currentPageCompanyRequests - 1)}
                  disabled={currentPageCompanyRequests === 1}
                  className={`px-2 py-1 rounded-md ${currentPageCompanyRequests === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                >
                  {'<'}
                </button>

                {/* Botão para a primeira página */}
                {currentPageCompanyRequests > 2 && (
                  <>
                    <button
                      onClick={() => handlePageChangeCompanyRequests(1)}
                      className="px-2 py-1 rounded-md bg-gray-300"
                    >
                      1
                    </button>
                    {currentPageCompanyRequests >= 3 && <span className="px-2 py-1">...</span>}
                  </>
                )}

                {/* Botões ao redor da página atual */}
                {Array.from({ length: 3 }, (_, i) => {
                  const page = currentPageCompanyRequests - 1 + i;
                  if (page > 0 && page <= companyRequestList.totalPages) {
                    return (
                      <button
                        key={page}
                        onClick={() => handlePageChangeCompanyRequests(page)}
                        className={`px-2 py-1 rounded-md ${page === currentPageCompanyRequests ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                      >
                        {page}
                      </button>
                    );
                  }
                  return null;
                })}

                {/* Botão para a última página */}
                {currentPageCompanyRequests < companyRequestList.totalPages - 1 && (
                  <>
                    {currentPageCompanyRequests < companyRequestList.totalPages - 2 && <span className="px-2 py-1">...</span>}
                    <button
                      onClick={() => handlePageChangeCompanyRequests(companyRequestList.totalPages)}
                      className="px-2 py-1 rounded-md bg-gray-300"
                    >
                      {companyRequestList.totalPages}
                    </button>
                  </>
                )}

                <button
                  onClick={() => handlePageChangeCompanyRequests(currentPageCompanyRequests + 1)}
                  disabled={currentPageCompanyRequests === companyRequestList.totalPages}
                  className={`px-2 py-1 rounded-md ${currentPageCompanyRequests === companyRequestList.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                >
                  {'>'}
                </button>
              </div>

            </div>
          </div>

        </div>
  
        {/* Modals */}
        { requestOnCancelModal && 
        <div className="absolute">
          <CancelModal
            isModalOpen={cancelModal}
            setModalOpen={() => {
              setCancelModal(!cancelModal);
            }}
            requestId={requestOnCancelModal}
          ></CancelModal>
        </div>
        }
  
        {requestOnDetailsModal && 
          <div className="absolute">
            <RequestDetailsModal
              isModalOpen={requestDetailsModal}
              setModalOpen={() => {
                setRequestDetailsModal(!requestDetailsModal);
              }}
              requestId={requestOnDetailsModal}
            ></RequestDetailsModal>
          </div>
        }

        {requestOnCreateReverseModal &&
          <div className="absolute">
            <CreateReverseModal
              isModalOpen={createReverseModal}
              setModalOpen={() => {
                setCreateReverseModal(!createReverseModal);
              }}
              requestId={requestOnCreateReverseModal}
            ></CreateReverseModal>
          </div>
        }
  
      </div>
      </div>
    )
  
  
}
